'use strict';

module.exports = /*@ngInject*/ ["ProjectService", "$stateParams", function (ProjectService, $stateParams) {
    var error = this;
    var codeExplanation = {
        "403" : "Forbidden",
        "404" : "The page you requested does not exist"
    };

    error.code = $stateParams.error;
    error.msg = codeExplanation[error.code];
    error.projectId = ProjectService.getSelectedProjectId();
}];